import { AVATAR_URL } from 'constants/api';
import Image from 'global/Image';
import { handleErrorAvatar } from 'utils/general';
import { MemberAvatarContainer } from './styled';
import { DATA_COMPONENT_GROUP_INVITATION_MEMBER_AVATAR_IMAGE } from './__tests__/constant';

interface MemberAvatarProps {
  username: string;
  src: string;
}

function MemberAvatar({ username, src }: MemberAvatarProps) {
  const avatarUrl = src?.startsWith('http') ? src : `${AVATAR_URL}/${src}`;

  return (
    <MemberAvatarContainer>
      <Image
        data-cy={DATA_COMPONENT_GROUP_INVITATION_MEMBER_AVATAR_IMAGE}
        src={avatarUrl}
        alt={username}
        onError={(e) => handleErrorAvatar(e, username)}
      />
    </MemberAvatarContainer>
  );
}

export default MemberAvatar;
